import { CREATE_FORM, ENTITY_REGISTER, GET_ENTITY_TYPE_FORMS } from "@/utils/constants/constants.js";
import { validate_non_empty_string, validate_non_sub_zero_number } from "@/utils/validations/validate_inputs";
import axios from "axios";

export default {
  methods: {
    get_forms() {
      this.form_list = [];

      axios
        .get(GET_ENTITY_TYPE_FORMS, {
          headers: this.headers,
          params: { entity_type_id: this.entity_type_id },
        })
        .then(response => {
          const parsed = JSON.parse(response.data);
          if (parsed.data && parsed.data.length > 0) {
            this.form_list = parsed.data;
            this.prep_tables();
          }
        })
        .catch(error => {
          this.show_error("Error getting forms: " + error);
        });
    },
    prep_tables() {
      if (!this.form_list.length) return;

      const rows = this.form_list.map(form => ({
        form_id: form.id,
        Form: form.form_name,
        Description: form.form_description,
        Status: form.status,
        "Date Created": this.format_date(form.date_created),
      }));

      this.form_table_headers = Object.keys(rows[0]);
      this.table_safe_form_list = rows;
    },
    create_form() {
      if (!validate_non_empty_string(this.form_name)) {
        this.show_error("Form name is required.");
        return;
      }

      if (this.form_description !== "" && !validate_non_empty_string(this.form_description)) {
        this.show_error("Form description");
        return;
      }

      axios
        .post(
          CREATE_FORM,
          {
            project_id: this.project_id,
            form_name: this.form_name,
            form_description: this.form_description || null,
          },
          { headers: this.headers }
        )
        .then(() => {
          this.show_success(`Form ${this.form_name} created successfully.`);
          sessionStorage.setItem("form_name", this.form_name);
          this.close_modal("create_form");
          this.get_forms();
        })
        .catch(() => {
          this.show_error("Error creating entity form: Form already exists");
          this.close_modal("create_form");
        });
    },
    selected_share_form_id(form_id) {
      this.selected_form_id = form_id;
    },
    share_trust_setup() {
      if (!validate_non_sub_zero_number(parseInt(this.selected_form_id, 10))) {
        this.show_error("Please select a form to share");
        return;
      }

      if (!this.email || !this.email.includes("@")) {
        this.show_error("Please enter a valid email address");
        return;
      }
      axios
        .post(
          ENTITY_REGISTER,
          {
            form_id: parseInt(this.selected_form_id, 10),
            email: this.email,
          },
          { headers: this.headers }
        )
        .then(() => {
          this.show_success("Company form successfully shared.");
          this.close_modal("share_trust_form");
          this.email = "";
        })
        .catch((error) => {
          this.show_error(
            error?.response?.data?.message ||
              "Cannot share form, user with email already exists"
          );
          this.close_modal("share_trust_form");
        });
    }
  },
};
